import React from 'react';
import { CountdownTimer } from './CountdownTimer';
export function FinalCTA() {
  return <section className="py-24 px-6 bg-nocheLight border-t border-petroleoLight" data-id="element-119">
      <div className="max-w-4xl mx-auto text-center" data-id="element-120">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-8" data-id="element-121">
          ⏰ ÚLTIMA OPORTUNIDAD AL PRECIO DE LANZAMIENTO
        </h2>

        <div className="mb-12" data-id="element-122">
          <CountdownTimer data-id="element-123" />
        </div>

        <div className="space-y-6 max-w-2xl mx-auto" data-id="element-124">
          {/* Option 1 */}
          <div className="bg-petroleo rounded-2xl p-6 border border-petroleoLight flex flex-col md:flex-row items-center justify-between gap-6" data-id="element-125">
            <div className="text-left" data-id="element-126">
              <h4 className="text-xl font-bold text-white" data-id="element-127">
                📘 MEGAPACK DOCENTE
              </h4>
              <div className="flex items-center gap-3 mt-2" data-id="element-128">
                <span className="text-gray-400 line-through text-sm" data-id="element-129">
                  $89.000
                </span>
                <span className="text-2xl font-bold text-white" data-id="element-130">
                  $19.990 <span className="text-sm text-gray-300" data-id="element-131">ARS</span>
                </span>
              </div>
            </div>
            <a href="https://www.bibliotecasdigitales.store/checkouts/cn/hWNC3E2Ac5Ul1LShxH6jwS2M/es-ar?_r=AQABdYqjLg5UUZFA4jNsRAT5afNnhJQ5SjWUn7cGz-dSVq0&cart_link_id=LqRVGwQM&preview_theme_id=154708803747" target="_blank" rel="noopener noreferrer" className="group w-full md:w-auto flex flex-col items-center justify-center gap-0.5 bg-amarillo hover:bg-amarilloHover text-noche font-bold py-4 px-6 rounded-xl transition-all shadow-lg hover:shadow-xl hover:-translate-y-0.5" data-id="element-132">
              <span className="flex items-center gap-2 text-lg leading-tight" data-id="element-133">
                <span data-id="element-134">⚡</span>
                <span data-id="element-135">QUIERO MI MEGAPACK</span>
                <span data-id="element-136">📚</span>
              </span>
              <span className="text-xs font-semibold text-noche/70 tracking-wide uppercase" data-id="element-137">
                6 Tomos + 6 Bonos
              </span>
            </a>
          </div>

          {/* Option 2 */}
          <div className="bg-petroleo rounded-2xl p-6 border-2 border-tealBrand flex flex-col md:flex-row items-center justify-between gap-6 relative shadow-[0_0_30px_rgba(20,184,166,0.1)]" data-id="element-138">
            <div className="absolute -top-3 left-6 bg-tealBrand text-noche text-xs font-bold px-3 py-1 rounded-full" data-id="element-139">
              MÁS POPULAR
            </div>
            <div className="text-left mt-2 md:mt-0" data-id="element-140">
              <h4 className="text-xl font-bold text-white" data-id="element-141">
                🏆 MEGAPACK + CEREBRO DIGITAL
              </h4>
              <div className="flex items-center gap-3 mt-2" data-id="element-142">
                <span className="text-gray-400 line-through text-sm" data-id="element-143">
                  $119.000
                </span>
                <span className="text-2xl font-bold text-white" data-id="element-144">
                  $27.990 <span className="text-sm text-gray-300" data-id="element-145">ARS</span>
                </span>
              </div>
            </div>
            <a href="https://www.bibliotecasdigitales.store/checkouts/cn/hWNC3ERKGkBLlKbBXeZgwHS6/es-ar?_r=AQABI4oUCQjYhRQVhqYGOzk2F25hFI0BRCcSYn5rxUsVdQc&cart_link_id=RKWwAu7G&preview_theme_id=154708803747" target="_blank" rel="noopener noreferrer" className="group w-full md:w-auto flex flex-col items-center justify-center gap-0.5 bg-amarillo hover:bg-amarilloHover text-noche font-bold py-4 px-6 rounded-xl transition-all shadow-lg hover:shadow-xl hover:-translate-y-0.5" data-id="element-146">
              <span className="flex items-center gap-2 text-lg leading-tight" data-id="element-147">
                <span data-id="element-148">⚡</span>
                <span data-id="element-149">LO QUIERO COMPLETO</span>
                <span data-id="element-150">📚</span>
              </span>
              <span className="text-xs font-semibold text-noche/70 tracking-wide uppercase" data-id="element-151">
                Megapack + Cerebro Digital
              </span>
            </a>
          </div>
        </div>
      </div>
    </section>;
}